export const RECEIVE_FILES = 'app/composents/browse/RECEIVE_FILES'

export const BROWSE_TOGGLE_BRANCH = 'app/composents/browse/BROWSE_TOGGLE_BRANCH'
export const BROWSE_SEARCH_BRANCH = 'app/composents/browse/BROWSE_SEARCH_BRANCH'

export const BROWSE_REQUEST_BRANCH_CONTENT = 'app/composents/browse/BROWSE_REQUEST_BRANCH_CONTENT'
export const BROWSE_RECEIVE_BRANCH_CONTENT = 'app/composents/browse/BROWSE_RECEIVE_BRANCH_CONTENT'
export const BROWSE_FORWARD_BRANCH_CONTENT = 'app/composents/browse/BROWSE_FORWARD_BRANCH_CONTENT'

export const BROWSE_REQUEST_FILE_CONTENT = 'app/composents/browse/BROWSE_REQUEST_FILE_CONTENT'
export const BROWSE_RECEIVE_FILE_CONTENT = 'app/composents/browse/BROWSE_RECEIVE_FILE_CONTENT'
export const BROWSE_FORWARD_FILE_CONTENT = 'app/composents/browse/BROWSE_FORWARD_FILE_CONTENT'

import Promise from 'es6-promise'

export function requestFileContent(dispatch, conf, file) {
    return new Promise((resolve, reject) => {
        dispatch({
            type: BROWSE_REQUEST_FILE_CONTENT
        });
        dispatch({
            type: conf.reducer, // we go there
            typeForBrowse: BROWSE_RECEIVE_FILE_CONTENT, // for that
            service: conf.service, // using this service
            file, resolve, reject
        })
    });
}

export function requestBranchContent(dispatch, conf, branch, query={}) {
    return new Promise((resolve, reject) => {
        dispatch({
            type: BROWSE_REQUEST_BRANCH_CONTENT
        });
        dispatch({
            type: conf.reducer, // we go there
            typeForBrowse: BROWSE_RECEIVE_BRANCH_CONTENT, // for that
            service: conf.service, // using this service
            branch, resolve, reject, query
        })
    });
}

export function toggleBranch(dispatch, conf, branch) {
    return new Promise((resolve, reject) => {
        dispatch({
            type: conf.reducer,
            typeForBrowse: BROWSE_TOGGLE_BRANCH,
            service: conf.service,
            branch, resolve, reject
        })
    });
}

export function search(dispatch, conf, value) {
    return new Promise((resolve, reject) => {
        dispatch({
            type: conf.reducer,
            typeForBrowse: BROWSE_SEARCH_BRANCH,
            service: conf.service,
            value, resolve, reject
        })
    });
}
